import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDone = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.2874 19.3053C10.7789 19.3053 11.1621 19.1137 11.4287 18.7138L19.2256 6.6519C19.4255 6.35202 19.5005 6.08546 19.5005 5.82722C19.5005 5.16915 19.0173 4.69434 18.3426 4.69434C17.8761 4.69434 17.5929 4.86094 17.3097 5.31076L10.2541 16.4897L6.63887 11.9082C6.36398 11.5666 6.08076 11.4167 5.67259 11.4167C4.98952 11.4167 4.49805 11.8998 4.49805 12.5662C4.49805 12.8578 4.59801 13.1327 4.83958 13.4242L9.15455 18.7388C9.47109 19.1303 9.82096 19.3053 10.2874 19.3053Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgDone);
export default ForwardRef;
